// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f8a914bb","147":"9ecb289f","295":"75ce2705","362":"a82e5cbb","574":"9a90e6eb","818":"65ff7e33","899":"1ff96a69","900":"07eceeca","996":"877d83fe"}[chunkId] + ".chunk.js";
};